export default "__VITE_ASSET__c6d8e44a__"